// Unified analytics helper for GA4 + PostHog.
// GA4 is loaded via <script> in public/index.html.
// PostHog is initialized lazily on first import.

import posthog from "posthog-js";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

let posthogReady = false;

export function initAnalytics() {
  if (posthogReady || !POSTHOG_KEY || typeof window === "undefined") return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    person_profiles: "identified_only",
  });
  posthogReady = true;
}

export function trackEvent(name, props = {}) {
  try {
    if (posthogReady) posthog.capture(name, props);
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, props);
    }
  } catch (e) {
    // Analytics must never crash the app.
    console.warn("analytics.trackEvent failed", e);
  }
}

export function identifyUser(user) {
  if (!user) return;
  try {
    if (posthogReady) {
      posthog.identify(user.user_id || user.email, {
        email: user.email,
        name: user.name,
        subscription_tier: user.subscription_tier,
      });
    }
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("set", { user_id: user.user_id || user.email });
    }
  } catch (e) {
    console.warn("analytics.identifyUser failed", e);
  }
}

export function resetUser() {
  try {
    if (posthogReady) posthog.reset();
  } catch (e) {
    console.warn("analytics.resetUser failed", e);
  }
}
